import * as React from "react";
import { AiOutlineBtn } from "./components/ui/AiOutlineBtn";
import { IconCheck, IconInfo, IconPencil } from "./icons";

export type SuggestionEditorProps = {
  value: string;
  onChange: (value: string) => void;
  onApply: () => void;
  onCancel: () => void;
  disabled?: boolean;
  onKeyDown?: (e: React.KeyboardEvent) => void;
};

export const SuggestionEditor: React.FC<SuggestionEditorProps> = ({
  value,
  onChange,
  onApply,
  onCancel,
  disabled,
  onKeyDown,
}) => {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  React.useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(Math.max(el.scrollHeight, 180), 280)}px`;
  }, [value]);

  return (
    <>
      <div className="ai-analysis__content ai-analysis__content--editing">
        <div className="ai-analysis__content-toolbar" style={{ padding: "8px 12px", borderBottom: "1px solid var(--border-soft)" }}>
          <span className="ai-analysis__editing-label">
            <IconPencil />
            Editing suggestion
          </span>
          <span className="ai-analysis__char-count">{value.length.toLocaleString()} chars</span>
        </div>
        <textarea
          ref={textareaRef}
          className="ai-analysis__editor"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            e.stopPropagation();
            onKeyDown?.(e);
          }}
        />
        <div className="ai-analysis__content-footer" style={{ padding: "8px 12px", borderTop: "1px solid var(--border-soft)" }}>
          <AiOutlineBtn disabled={disabled} onClick={onCancel}>
            Cancel
          </AiOutlineBtn>
          <AiOutlineBtn primary disabled={disabled} onClick={onApply}>
            <IconCheck size={11} />
            Apply edit
          </AiOutlineBtn>
        </div>
      </div>
      <p className="ai-analysis__hint">
        <IconInfo />
        <span>Applying your edit inserts your version into the document.</span>
      </p>
    </>
  );
};
